import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/',
    component: loadableWithRetry(() => import('./OrdersTable')),
    name: 'orders',
    exact: true,
  },
  {
    path: '/:id',
    name: 'singleOrder',
    component: loadableWithRetry(() => import('./SingleOrder')),
  },
]

export default routes
